import React from "react";
import * as styles from "../../styles/components/product/deployment-options.module.css";
import SectionHeader from "../product-section-header";
import Container from "../container";
import { imageUrlFor } from "../../lib/image-url";
import { buildImageObj } from "../../lib/helpers";
import PortableText from "../portableText";

const DeploymentOptions = (props) => {
  const { title, options, deploymentHeader } = props;
  console.log("options", options);
  return (
    <div className={styles.root} id="deployment-options">
      {title && <SectionHeader title={title} />}
      <Container>
        <div className={styles.desktopTable}>
          <div className={`${styles.row} ${styles.headerRow}`}>
            <div className={styles.headerCell}></div>
            {deploymentHeader.map((header, index) => (
              <div className={styles.headerCell} key={index}>
                <img
                  src={imageUrlFor(buildImageObj(header.image))
                    .auto("format")
                    .url()}
                  className={styles.headerImage}
                  alt={header.title}
                />
                <p className={styles.headerText}>{header.title}</p>
              </div>
            ))}
          </div>
          {options.map((content, index) => (
            <div className={styles.row} key={index}>
              <div className={styles.cell}>{content.header}</div>
              {options.find((i) => i._rawDedicated) && (
                <div className={styles.cell}>
                  <PortableText blocks={content?._rawDedicated} />
                </div>
              )}
              {options.find((i) => i._rawOnDemand) && (
                <div className={styles.cell}>
                  <PortableText blocks={content?._rawOnDemand} />
                </div>
              )}
              {options.find((i) => i._rawHybrid) && (
                <div className={styles.cell}>
                  <PortableText blocks={content?._rawHybrid} />
                </div>
              )}
            </div>
          ))}
        </div>
        <div className={styles.mobileTable}>
          <div className={styles.mobileTableHeader}>
            {deploymentHeader.map((header, index) => (
              <div className={styles.headerCell} key={index}>
                <img
                  src={imageUrlFor(buildImageObj(header.image))
                    .auto("format")
                    .url()}
                  className={styles.headerImage}
                  alt={header.title}
                />
                <p className={styles.headerText}>{header.title}</p>
              </div>
            ))}
          </div>

          <div className={styles.mobileTableContent}>
            {options.map((content, index) => (
              <div className={styles.contentGroup} key={index}>
                <div className={styles.mobileRow}>{content.header}</div>
                <div className={styles.flex}>
                  {options.find((i) => i._rawDedicated) && (
                    <div className={styles.mobileCell}>
                       <PortableText blocks={content?._rawDedicated}  />
                    </div>
                  )}
                  {options.find((i) => i._rawOnDemand) && (
                    <div className={styles.mobileCell}>
                        <PortableText blocks={content?._rawOnDemand} />
                    </div>
                  )}
                  {options.find((i) => i._rawHybrid) && (
                    <div className={styles.mobileCell}>
                        <PortableText blocks={content?._rawHybrid} />
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default DeploymentOptions;
